import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    chartContainer: {
        position: 'relative',
    },
    chart: {
        ...(theme.palette.type === 'dark'
            ? {
                  '& .highcharts-axis-title': {
                      color: '#C5C5C5 !important',
                      fill: '#C5C5C5 !important',
                  },
              }
            : {}),
    },
}));
